import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import './styles.scss'

import connector from 'src/decorators/connector'
import { IStoresMap } from 'src/types'
import OutsideClickHandler from 'react-outside-click-handler';



class Discount extends Component<ReturnType<typeof storesToProps>> {
  public state = { discount: 0 }

  public componentDidMount() {
    const price = this.props.busket.allPrice
    if (50000 <= price && price < 100000) {
      this.setState({ discount: 5 })
    }
    if (100000 <= price && price < 150000) {
      this.setState({ discount: 7 })
    }
    if (150000 <= price && price < 200000) {
      this.setState({ discount: 10 })
    }
    if (200000 <= price && price < 250000) {
      this.setState({ discount: 12 })
    }
    if (250000 <= price && price < 500000) {
      this.setState({ discount: 15 })
    }
    if (500000 <= price && price < 1000000) {
      this.setState({ discount: 20 })
    }
    if (1000000 <= price) {
      this.setState({ discount: 25 })
    }
    return this.state.discount
  }
  public componentWillUpdate() {
    const price = this.props.busket.allPrice
    if (50000 <= price && price < 100000 && this.state.discount !== 5) {
      this.setState({ discount: 5 })
    }
    if (100000 <= price && price < 150000 && this.state.discount !== 7) {
      this.setState({ discount: 7 })
    }
    if (150000 <= price && price < 200000 && this.state.discount !== 10) {
      this.setState({ discount: 10 })
    }
    if (200000 <= price && price < 250000 && this.state.discount !== 12) {
      this.setState({ discount: 12 })
    }
    if (250000 <= price && price < 500000 && this.state.discount !== 15) {
      this.setState({ discount: 15 })
    }
    if (500000 <= price && price < 1000000 && this.state.discount !== 20) {
      this.setState({ discount: 20 })
    }
    if (1000000 <= price && this.state.discount !== 25) {
      this.setState({ discount: 25 })
    }

  }

  public render() {

    return (<>
      <div style={{ display: 'none' }}>{this.props.busket.allPrice}</div>

      <div className='discount' style={{ display: 'none' }}>{this.state.discount}%</div>
      <div className="container">
        <div className="onHover">
          <div className="listDisconts">
            <div className={`item ${this.state.discount === 5 ? "active" : ''}`}>
              <div className="sum">50 000 руб</div>
              <div className="discount">- 5 %</div>
            </div>
            <div className={`item ${this.state.discount === 7 ? "active" : ''}`}>
              <div className="sum">100 000 руб</div>
              <div className="discount">- 7 %</div>
            </div>
            <div className={`item ${this.state.discount === 10 ? "active" : ''}`}>
              <div className="sum">150 000 руб</div>
              <div className="discount">- 10 %</div>
            </div>
            <div className={`item ${this.state.discount === 12 ? "active" : ''}`}>
              <div className="sum">200 000 руб</div>
              <div className="discount">- 12 %</div>
            </div>
            <div className={`item ${this.state.discount === 15 ? "active" : ''}`}>
              <div className="sum">250 000 руб</div>
              <div className="discount">- 15 %</div>
            </div>
            <div className={`item ${this.state.discount === 20 ? "active" : ''}`}>
              <div className="sum">500 000 руб</div>
              <div className="discount">- 20 %</div>
            </div>
            <div className={`item ${this.state.discount === 25 ? "active" : ''}`}>
              <div className="sum">1 000 000 руб</div>
              <div className="discount">- 25 %</div>
            </div>
          </div>
          <div>
            Скидка зависит от суммы в корзине.<br />
            Все цены указаны без скидки.<br />
            Окончательная сумма со скидкой<br />
            рассчитывается корзине.<br />
          </div>
          <div className="close" >&#8595;</div>
        </div>
      </div>
    </>
    )

  }
}


const storesToProps = ({ store }: IStoresMap) => ({
  busket: store.BusketStore,
  configuratorStore: store.configuratorStore,
})

export default connector(storesToProps)(Discount)